<template>

    <div class="bg-secondary py-5">

        <inertia-head :title="title">
        </inertia-head>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col" style="max-width: 600px;">
                    <div class="card rounded-3 shadow border-0 text-center">
                        <div class="card-header fw-bold">{{ title }}</div>
                        <div class="card-body">
                            <div class="mb-2">
                                <i class="bi bi-info-circle display-2 text-secondary"></i>
                            </div>
                            <div class="">{{ description }}</div>
                            <code class="">{{ message }}</code>
                        </div>
                        <div class="card-footer">
                            <inertia-link class="btn btn-outline-dark" :href="route('home')">
                                {{ __('Zur Startseite') }}
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import SlimLayout from '@/shared/Layouts/SlimLayout';

    export default {
        layout: SlimLayout,
        props: [
            'status',
            'message',
        ],
        computed: {
            title() {
                return {
                    503: this.__('Service Unavailable'),
                    500: this.__('Server Error'),
                    404: this.__('Page Not Found'),
                    403: this.__('Forbidden'),
                }[this.status]
            },
            description() {
                return {
                    503: this.__('Sorry, we are doing some maintenance. Please check back soon.'),
                    500: this.__('Whoops, something went wrong on our servers.'),
                    404: this.__('Sorry, the page you are looking for could not be found.'),
                    403: this.__('Sorry, you are forbidden from accessing this page.'),
                }[this.status]
            },
        },
    }
</script>
